var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickdet02(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66455 1.66614V4.9984",
    stroke: "#F0E1CE",
    strokeOpacity: 0.7,
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3291 1.66614V4.9984",
    stroke: "#F0E1CE",
    strokeOpacity: 0.7,
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8283 3.33228H4.1654C3.24522 3.33228 2.49927 4.07823 2.49927 4.99841V16.6613C2.49927 17.5815 3.24522 18.3275 4.1654 18.3275H15.8283C16.7485 18.3275 17.4945 17.5815 17.4945 16.6613V4.99841C17.4945 4.07823 16.7485 3.33228 15.8283 3.33228Z",
    stroke: "#F0E1CE",
    strokeOpacity: 0.7,
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49927 8.33069H17.4945",
    stroke: "#F0E1CE",
    strokeOpacity: 0.7,
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickdet02);
export default __webpack_public_path__ + "static/media/tickdet02.d438e43da7d2c738254d7f9fa214c10c.svg";
export { ForwardRef as ReactComponent };